import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function CustomMetaTags(props) {
    if(props.title){
        return (
            <>
                <Helmet>
                    <title>{props.title}</title>
                </Helmet>
            </>
        )
    }
}
